<template>
  <div class="page page-with-bg">
    <div class="page-header with-actions">
      <div class="actions">
        <b-btn @click="exportHealthQuotientAnswers" variant="success" class="ml-auto mr-3">Health Quotient Answers +</b-btn>
        <b-btn @click="exportHistoricalData" variant="success">Historical Data</b-btn>
      </div>
    </div>
    <div class="page-form-wrap">
      <div class="page-form-header">
        <dt-filters-group :tableId="tableId">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-4">
              <v-form-group :staticLabel="true" icon="magnifier" label="Search">
                <dt-filter-input id="patient-name-filter"
                                 column-name="Name"
                                 placeholder="First or Last Name" />
              </v-form-group>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <v-form-group :staticLabel="true" icon="calendar" label="Date of Order">
                <dt-filter-daterange id="creation-date-filter"
                                     column-name="CreateDate"
                                     placeholder="Any"
                                     @selected="onDateOfOrderSelect" />
              </v-form-group>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <v-form-group :staticLabel="true" icon="calendar" label="Date of Completion">
                <dt-filter-daterange id="completion-date-filter"
                                     column-name="CompletionDate"
                                     placeholder="Any"
                                     @selected="onDateOfCompletionSelect" />
              </v-form-group>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <v-form-group :staticLabel="true" icon="magnifier" label="ClientId">
                <dt-filter-input id="client-filter"
                                 column-name="ClientId"
                                 placeholder="Client Id" />
              </v-form-group>
            </div>
            <div class="col-12 col-md-6 col-lg-4">
              <v-form-group :staticLabel="true" label="Tags">
                <dt-filter-select id="report-tag-filter"
                                  column-name="ReportTags"
                                  :options="tagFilterOptions"
                                  placeholder="Tags" 
                                  multiple/>
              </v-form-group>
            </div>
          </div>
        </dt-filters-group>
        <dt-datatable ref="adminList"
                      :id="tableId"
                      url="/admin/adminList"
                      :columns="columns"
                      :dt-options="dtOptions">
          <template #report-tags="{ data }">
            <span class="text-wrap" v-for="(reportTag, index) in data.reportTags" :key="index">{{ reportTag.tag.name }}<span v-if="index !== data.reportTags.length - 1">, </span><br /></span>
          </template>
        </dt-datatable>
      </div>
    </div>

    <export-report-historical-data-modal ref="exportReportHistoricalDataModalRef" />
  </div >
</template >

<script>
  import { defaults } from "vue-datatables.net";
  import adminService from "../../../services/admin-service";
  import exportReportHistoricalDataModal from 'components/common/modals/export-report-historical-data-modal';

  export default {
    components: {
      exportReportHistoricalDataModal
    },

    data() {
      return {
        tableId: `admin-list-id${this.$auth.id}`,
        dtOptions: {
          language: {
            ...defaults.language,
            emptyTable: "No users to display."
          },
          order: [[1, "desc"]],
          lengthMenu: [10, 25, 50, 75, 100, 200]
        },
        tagFilterOptions: [],
        selectedDateOfOrder: '',
        selectedDateOfCompletion: ''
      };
    },

    computed: {
      columns() {
        return [
          { name: "ClientId", title: "Client ID" },
          { name: "Id", title: "Order ID" },
          { name: "Type", title: "Order Type" },
          { name: "CreationDate", title: "Creation Date" },
          { name: "CompletionDate", title: "Completion Date" },
          { name: "Name", title: "Name" },
          { name: "ReportTags", title: "Tags", sortable: false }
        ];
      }
    },

    async created() {
      let tags = await adminService.getTags();
      tags.forEach(t => this.tagFilterOptions.push({
        text: t.name,
        value: t.id
      }))
    },

    methods: {
      onDateOfOrderSelect(val) {
        this.selectedDateOfOrder = val;
      },

      onDateOfCompletionSelect(val) {
        this.selectedDateOfCompletion = val;
      },

      async exportHealthQuotientAnswers() {
        await adminService.downloadHealthQuotient({
          dateOfOrderStart: this.selectedDateOfOrder?.start,
          dateOfOrderEnd: this.selectedDateOfOrder?.end,
          dateOfCompletionStart: this.selectedDateOfCompletion?.start,
          dateOfCompletionEnd: this.selectedDateOfCompletion?.end
        })
      },

      exportHistoricalData() {
        this.$refs.exportReportHistoricalDataModalRef.show();
      }
    }
  };
</script>